module.exports = __webpack_public_path__ + "img/c.8fafa7d7.png";